import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';
import { FilePathRenderModule } from '../../file-path-table-render/file-path-table-render.module';
import { CreateOnAccessScanModule } from '../../on-access-scan/create-on-access-scan/create-on-access-scan.module';
import { CreateOnDemandScanModule } from '../../on-demand-scan/create-on-demand-scan/create-on-demand-scan.module';
import { CreateFsScanMissionPolicyCardComponent } from './create-fs-scan-mission-policy-card.component';
import { TypePathDetailTableModule } from '../../type-path-detail-table/type-path-detail-table.module';

@NgModule({
    declarations: [CreateFsScanMissionPolicyCardComponent],
    exports: [CreateFsScanMissionPolicyCardComponent],
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
        FilePathRenderModule,
        CreateOnDemandScanModule,
        CreateOnAccessScanModule,
        TypePathDetailTableModule,
    ],
})
export class CreateFsScanMissionPolicyCardModule { }
